import {FloatingPortal} from '@floating-ui/react';

import {CSSProperties, ReactNode, RefObject} from 'react';

import {isFalse} from 'ramda-adjunct';

import {suffixTestId, TestIdProps} from 'shared/web';

export interface AnimatedPopperProps extends TestIdProps {
  isOpen: boolean;
  children?: ReactNode;
  clickRef?: RefObject<HTMLDivElement | null>;
  floatingRef?: (node: HTMLElement | null) => void;
  floatingStyles: CSSProperties;
  transitionStyles: CSSProperties;
  /**
   * Use a portal to render the popper outside the DOM hierarchy.
   * Useful when the popper is inside a stacking context (e.g., position: sticky).
   * When enabled, the popper will be rendered using FloatingPortal, allowing it
   * to appear above other elements that would normally cover it due to stacking contexts.
   */
  usePortal?: boolean;
}

export function AnimatedPopper(props: AnimatedPopperProps) {
  if (isFalse(props.isOpen)) {
    return;
  }

  const popperContent = (
    <div
      ref={props.floatingRef}
      data-testid={suffixTestId('animatedPopperContent', props)}
      style={{...props.floatingStyles, zIndex: 999}}
    >
      <div ref={props.clickRef} style={props.transitionStyles}>
        {props.children}
      </div>
    </div>
  );

  if (props.usePortal) {
    return <FloatingPortal>{popperContent}</FloatingPortal>;
  }

  return popperContent;
}
